export interface AttendanceEmployeeType {
    id?: number;
    contact_id?: number;
    personal_info_id?: number;
    daily_hours?: number;
    daily_wage?: number;
    status?: 1 | 0;
}

// to single object maping
export const mapAttendanceEmployeeType = (data: any): AttendanceEmployeeType => {
    if (!data) {
        throw new Error('Invalid Data')
    }
    const res: AttendanceEmployeeType = {
        id: data.id,
        contact_id: data.contact_id,
        personal_info_id: data.personal_info_id,
        daily_hours: data.daily_hours,
        daily_wage: data.daily_wage,
        status: data.status,
    }
    return res;
}

// maping list objects
export const mapAttendanceEmployeeTypes = (data: any[]): AttendanceEmployeeType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }
    return data.map(mapAttendanceEmployeeType);
}